import React from 'react';

import { WithStyles, withStyles } from '@material-ui/core';

import storageService from '@lib/services/storageService';
import { Insurance } from '@lib/resources/types';

import ImageInsurance from '../ImageInsurance';

import styles from './InsuranceCaptureItem.styles';
import InsuranceCaptureDetailsSection from '../InsuranceCaptureDetailsSection';

interface InsuranceCaptureItemProps extends WithStyles<typeof styles> {
  item: Insurance;
  shouldShowEligibility?: boolean;
}

function InsuranceCaptureItem({ item, shouldShowEligibility, classes }: InsuranceCaptureItemProps) {
  const currentToken = storageService.getToken();
  const addTokenToURL = (url: string) => (url && currentToken ? `${url}?token=${currentToken}` : url);

  return (
    <div className={classes.container}>
      <InsuranceCaptureDetailsSection item={item} shouldShowEligibility={shouldShowEligibility} />
      {(item.url || item.urlBack) && (
        <div className={classes.imagesWrapper}>
          {item.url && <ImageInsurance url={addTokenToURL(item.url)} alt="front-card" />}
          {item.urlBack && <ImageInsurance url={addTokenToURL(item.urlBack)} alt="back-card" />}
        </div>
      )}
    </div>
  );
}

export default withStyles(styles)(InsuranceCaptureItem);
